<mat-form-field class="bday-picker">
  <input
    [formControl]="dateControl"
    [matDatepicker]="picker"
    [max]="maxDate"
    [placeholder]="placeholderLabel"
    matInput
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker startView="multi-year"></mat-datepicker>

  <mat-error *ngIf="dateControl.errors && dateControl.errors.matDatepickerParse">
    Please enter in MM/DD/YYYY format
  </mat-error>
</mat-form-field>
